var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-screen flex h-full sm:h-screen",attrs:{"id":"app"}},[_c('div',{staticClass:"app-container relative rounded-large self-center items-center mx-auto bg-white px-6 py-8 sm:px-8"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }